// extracted by mini-css-extract-plugin
export default {"criteriaInput":"SearchBarCriteriaInput_criteriaInput__UQ5hG","criteriaInputContainer":"SearchBarCriteriaInput_criteriaInputContainer__dyu0o"};